import { jwtDecode } from "jwt-decode";

export function decodeToken(token) {
  try {
    if (!token) return null;
    return jwtDecode(token); // returns the payload object
  } catch (e) {
    console.error("Invalid token", e);
    return null;
  }
}
